/*
 * Copyright (c) 2020
 * Company: G-Portal
 * Filename: getters.ts
 * Class: getters.ts
 * Author: Karl Magerl<karl@g-portal.com>
 * Version:
 */

import { GetterTree } from 'vuex';
import { sortMethods } from '../../service/payment/methods';
import { MutationRequestStatus, RootState } from '../types';
import {
  AdyenClientInformation, LagoPaymentMethod, PaymentMethod, PaymentMethodsState,
} from './types';

export const getters: GetterTree<PaymentMethodsState, RootState> = {
  methodsLoading: (state): boolean => state.paymentMethods.status === MutationRequestStatus.LOADING,
  methodsError: (state): boolean => state.paymentMethods.status === MutationRequestStatus.ERROR,
  methodsSuccess: (state): boolean => state.paymentMethods.status === MutationRequestStatus.SUCCESS,

  rechargeMethodsLoading:
    (state): boolean => state.rechargeMethods.status === MutationRequestStatus.LOADING,
  rechargeMethodsLoaded:
    (state): boolean => state.rechargeMethods.status === MutationRequestStatus.SUCCESS,
  rechargeMethodsError:
    (state): boolean => state.rechargeMethods.status === MutationRequestStatus.ERROR,

  setupMethodsLoading:
    (state): boolean => state.setupMethods.status === MutationRequestStatus.LOADING,
  setupMethodsLoaded:
    (state): boolean => state.setupMethods.status === MutationRequestStatus.SUCCESS,
  setupMethodsError:
    (state): boolean => state.setupMethods.status === MutationRequestStatus.ERROR,

  checkoutMethodsLoading:
    (state): boolean => state.checkoutMethods.status === MutationRequestStatus.LOADING,
  checkoutMethodsLoaded:
    (state): boolean => state.checkoutMethods.status === MutationRequestStatus.SUCCESS,
  checkoutMethodsError:
    (state): boolean => state.checkoutMethods.status === MutationRequestStatus.ERROR,

  rechargeMethods: (state): Array<PaymentMethod> => state.rechargeMethods.data?.methods
    ?.filter((method) => (method.gateway === 'custom' && ['balance', 'recurring'].includes(method.type) ? 0 : 1))
    .sort(sortMethods),

  setupMethods: (state): Array<PaymentMethod> => state.setupMethods.data?.methods
    ?.filter((method) => (method.gateway === 'custom' && ['balance', 'recurring'].includes(method.type) ? 0 : 1))
    .sort(sortMethods),

  checkoutMethods: (state): Array<PaymentMethod> => state.checkoutMethods.data?.methods
    ?.sort(sortMethods),

  preferableAmount: (state) => state.preferableTransactionAmount.data,
  preferableAmountLoading:
    (state) => state.preferableTransactionAmount.status === MutationRequestStatus.LOADING,

  sdk: (state): AdyenClientInformation => state.sdk,

  // Adyen SPM
  adyenSPM: (state): PaymentMethod => state.adyenSPM.data,
  adyenSPMLoading: (state): boolean => state.adyenSPM.status === MutationRequestStatus.LOADING,
  adyenSPMLoaded: (state): boolean => state.adyenSPM.status === MutationRequestStatus.SUCCESS,
  adyenSPMError: (state): boolean => state.adyenSPM.status === MutationRequestStatus.ERROR,

  // lago payment methods
  lagoMethods: (state): Array<LagoPaymentMethod> => state.lagoPaymentMethods,
  defaultLagoMethodId: (state): string => state.lagoDefaultPaymentMethod,
  defaultLagoMethod: (state): LagoPaymentMethod => state.lagoPaymentMethods
    .find((method) => method.id === state.lagoDefaultPaymentMethod),
  defaultLagoPaymentMethod: (_, storeGetters): PaymentMethod => {
    if (storeGetters.defaultLagoMethod == null) return null;

    return {
      gateway: 'lago-default',
      value: (storeGetters.defaultLagoMethod as LagoPaymentMethod).id,
      type: 'recurring',
      sort: 0,
      id: 0,
      name: 'Credit Card',
      supports_recurring: false,
      saved: true,
      meta: {
        card: (storeGetters.defaultLagoMethod as LagoPaymentMethod).card,
      },
    };
  },
};
